module.exports = __webpack_public_path__ + "img/mortar_symbol_red.03715dc5.svg";